import React, { useState } from 'react';
import PropTypes from 'prop-types';

const getInitialChars = (str = '', maxLen = 2) =>
  str
    .split(' ')
    .map((item) => item[0] && item[0].toUpperCase())
    .slice(0, maxLen)
    .join('');

const initialCharsCache = {}; // maintained to memoize getInitialChars fn calls

const _getInitialChars = (label, maxLen) => {
  const key = label + maxLen;
  if (initialCharsCache[key]) {
    return initialCharsCache[key];
  }
  return getInitialChars(label, maxLen);
};

const ProfilePhoto = ({ label, size, src }) => {
  // Fall back to initials when there is no image or it fails to load.
  const [hasError, setHasError] = useState(false);
  const showImage = Boolean(src) && !hasError;
  return (
    <div className="profile-photo" style={{ width: size, height: size }}>
      {showImage ? (
        <img
          className="profile-photo-img"
          src={src}
          alt={label}
          onError={() => setHasError(true)}
        />
      ) : (
        <div className="profile-photo-text">
          {_getInitialChars(label, 2) || '?'}
        </div>
      )}
    </div>
  );
};

ProfilePhoto.propTypes = {
  label: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  src: PropTypes.string,
};

ProfilePhoto.defaultProps = {
  src: '',
};

export default ProfilePhoto;
